/* TODO IMP-1215 IMP-1149 fix max-depth */
/* eslint-disable max-depth */
/* TODO IMP-1218 IMP-1149 fix no-await-in-loop */
/* eslint-disable no-await-in-loop */
import type { ChannelAuthorizerGenerator } from "pusher-js";

import { getBroadcastingAuthEndpoint } from "@/config/environmentUtils";
import { refreshAccessToken } from "@/services/auth";

const TIME_BEFORE_NEXT_ATTEMPT = 5000; // 5 seconds
const MAX_NUMBER_OF_ATTEMPTS = 2;

// This cannot be done inside the SDK since it doesn't use the same URL
export const authenticateUserToChannel = (
  socket_id: string,
  channel_name: string,
  user_token?: string | null
) => {
  // Connection ids
  const request_data = {
    socket_id: socket_id,
    channel_name: channel_name,
  };

  // Request parameter
  const parameters = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${user_token}`,
    },
    body: JSON.stringify(request_data),
  };

  return fetch(getBroadcastingAuthEndpoint(), parameters);
};

export const getPusherAuthorizer = (token?: string | null) => {
  const authorizer: ChannelAuthorizerGenerator = (channel) => ({
    authorize: async (socketId, callback) => {
      try {
        let auth_response: Response | null = await authenticateUserToChannel(
          socketId,
          channel.name,
          token
        );

        // If authentication failed with 401 refresh token and retry up to 3 times
        if (auth_response.status === 401) {
          let refresh_result = undefined;
          let access_token = token;
          let retries = 0;
          while (retries < MAX_NUMBER_OF_ATTEMPTS) {
            refresh_result = await refreshAccessToken();
            access_token = refresh_result?.accessToken;

            if (access_token !== undefined) break;
            else {
              // Else wait couple of seconds and retry
              await new Promise((r) => setTimeout(r, TIME_BEFORE_NEXT_ATTEMPT));
              retries++;
            }
          }
          if (access_token !== undefined) {
            auth_response = null;
            retries = 0;
            while (retries < MAX_NUMBER_OF_ATTEMPTS) {
              auth_response = await authenticateUserToChannel(
                socketId,
                channel.name,
                access_token
              );
              if (auth_response.status === 200) break;
              else {
                // Else wait couple of seconds and retry
                await new Promise((r) =>
                  setTimeout(r, TIME_BEFORE_NEXT_ATTEMPT)
                );
                retries++;
              }
            }
          }
        }
        if (auth_response?.status === 200) {
          const response_data = await auth_response.json();
          // TODO IMP-1149 fix callback
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-expect-error
          callback(false, { auth: response_data.auth });
        } else {
          callback(
            // TODO IMP-1149 fix callback
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-expect-error
            true,
            `Authentication failure, authentication request returned status codes ${auth_response?.status}`
          );
        }
      } catch (err) {
        // Log error in Pusher debug console

        // TODO IMP-1149 fix callback
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        callback(true, err);
      }
    },
  });

  return authorizer;
};
